<template>
  <div class="main">
       <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fstd/banner.jpg"
    ></landingBanner></a>
    <div class="plate">
      <h2>
        在线获取<span style="color: red">学费</span>&<span style="color: red"
          >创业</span
        >信息
      </h2>
      <h4>
        目前已有<span style="color: red">{{ num }}</span
        >人咨询了解过
      </h4>
      <div
        style="width: 100%; height: 50px; text-align: center; padding: 10px 0px"
      >
        <input
          type="text"
          style="
            width: 200px;
            height: 40px;
            border-bottom-right-radius: 0px;
            border-top-right-radius: 0px;
            border-bottom-left-radius: 50px;
            border-top-left-radius: 50px;
            border: 1px solid #b46636;
          "
        />
        <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
          <button
            style="
              width: 90px;
              height: 40px;
              border-top: 1px solid rgb(180, 102, 54);
              border-right: 1px solid rgb(180, 102, 54);
              border-bottom: 1px solid rgb(180, 102, 54);
              border-left: none;
              line-height: 39px;
              font-weight: 600;
              border-image: initial;
              border-bottom-right-radius: 50px;
              border-top-right-radius: 50px;
              color: rgb(255, 255, 255);
              background: rgb(180, 102, 54);
            "
          >
            立即获取
          </button></a
        >
      </div>
      <div style="width: 100%; height: 10px"></div>
    </div>
    <div class="plate">
      <h2>海量教学内容</h2>
      <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fstd/p1.jpg"
        ></van-image
      ></a>
    </div>
    <div style="background: #f5f5f5; padding: 5px 0; margin-top: -15px">
      <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fstd/p2.jpg"
        ></van-image
      ></a>
    </div>
    <div class="plate">
      <h2>学生作品</h2>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fstd/p3.jpg"
      ></van-image>
      <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
        <div class="tags">
          你可能还想看：
          <Button
            shape="circle"
            type="warning"
            ghost
            style="margin: 0 3px 3px 0"
            >法式甜点</Button
          >
          <Button
            shape="circle"
            type="warning"
            ghost
            style="margin: 0 3px 3px 0"
            >创意欧包</Button
          >
          <Button
            shape="circle"
            type="warning"
            ghost
            style="margin: 0 3px 3px 0"
            >私房烘焙</Button
          >
          <Button
            shape="circle"
            type="warning"
            ghost
            style="margin: 0 3px 3px 0"
            >韩式裱花</Button
          >
          <Button
            shape="circle"
            type="warning"
            ghost
            style="margin: 0 3px 3px 0"
            >翻糖蛋糕</Button
          >
          <Button
            shape="circle"
            type="warning"
            ghost
            style="margin: 0 3px 3px 0"
            >晚间课程</Button
          >
          <Button
            shape="circle"
            type="warning"
            ghost
            style="margin: 0 3px 3px 0"
            >周末兴趣</Button
          >
        </div></a
      >
    </div>
    <div style="background: #f5f5f5; padding: 5px 0; margin-top: -15px">
      <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fstd/p4.jpg"
        ></van-image
      ></a>
    </div>
    <div class="plate">
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fstd/p5.jpg"
      ></van-image>
      <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fstd/p6.jpg"
        ></van-image
      ></a>
    </div>
    <div class="plate" style="text-align: center">
      <h2>创业学子案例</h2>
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fstd/p7_1.jpg"
          ></van-image
        ></van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fstd/p7_2.jpg"
          ></van-image
        ></van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fstd/p7_3.jpg"
          ></van-image
        ></van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fstd/p7_4.jpg"
          ></van-image
        ></van-swipe-item>
      </van-swipe>
      <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
        <Button
          shape="circle"
          type="warning"
          style="width: 300px; font-size: 17px; font-weight: 600"
          >立即领取 创业秘籍</Button
        ></a
      >
    </div>
    <div class="plate">
      <h2>推荐更多热门课程</h2>
      <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/fstd/p8.jpg"
        ></van-image
      ></a>
    </div>
    <div class="plate">
      <indexTitle
        title1="选择课程 了解学费"
        title2="Choose a course to learn about tuition"
      ></indexTitle>
      <footerForm
        color="#fff"
        bag="#a96b04"
        words="点击获取学费报价"
      ></footerForm>
    </div>

    <foot></foot>
  </div>
</template>

<script>
export default {
  components: {
    landingBanner: () => import("@/components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    indexTitle: () => import("@/components/common/indexTitle"),
    footerForm: () => import("@/components/form/footerForm"),
  },
  mounted() {
    this.number();
    setInterval(this.number, 8000);
  },
  data() {
    return {
      num: 5432,
    };
  },
  methods: {
    number() {
      setTimeout(() => {
        this.num = 5432;
      }, 1000);
      setTimeout(() => {
        this.num = 5434;
      }, 3000);
      setTimeout(() => {
        this.num = 5436;
      }, 5000);
      setTimeout(() => {
        this.num = 5441;
      }, 7000);
      setTimeout(() => {
        this.num = 5442;
      }, 9000);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .van-swipe__indicators {
  bottom: 15px;
  left: 10%;
}
/deep/.ivu-input {
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 50px;
  border-top-left-radius: 50px;
  border: 1px solid #b46636;
}
h1,
h2,
h3,
h4 {
  text-align: center;
}
.plate {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  background: #fff;
}
.content {
  padding: 10px;
}
.more {
  width: 100%;
  height: 110px;
  //   border-bottom: 1px solid #eee;
  padding: 10px 0;
}
.more-1 {
  width: 45%;
  height: 90px;
  margin-right: 10px;
  float: left;
}
.more-2 {
  height: 90px;
  float: left;
}
.more-2-words {
  font-size: 13px;
  color: #fff;
}
</style>